import { Card, CardType, Session } from '@generated-types';

export const isOwnerOfCard = (card: Card, session: Session) => card.owner === session.user?.userId;

export const canMakeTransfer = (card: Card, session: Session) =>
    card.type === CardType.CREDIT && isOwnerOfCard(card, session);
